import { useId } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ParticipantFace, Stack, Typography } from '@src/components';
import { ThemeArtwork } from '@src/theme/Artwork';
import './DrawHelp.css';

export function CircleDrawHelp() {
  const { t } = useTranslation();
  const arrowId = `circle-arrow-${useId().replace(/:/g, '')}`;
  return (
    <Stack gap={4} className="circle-draw-help">
      <Typography as="p" role="body/base">
        {t('game.draw.circleHelp.intro')}
      </Typography>
      <figure className="circle-draw-help__example">
        <figcaption>{t('game.draw.circleHelp.example')}</figcaption>
        <div className="circle-draw-help__diagram">
          <svg viewBox="0 0 480 360" aria-hidden="true" focusable="false">
            <defs>
              <marker
                id={arrowId}
                viewBox="0 0 10 10"
                refX="8"
                refY="5"
                markerWidth="7"
                markerHeight="7"
                orient="auto-start-reverse"
              >
                <path d="M1 1 L8 5 L1 9" fill="none" stroke="currentColor" strokeWidth="1.8" />
              </marker>
            </defs>
            <g
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              markerEnd={`url(#${arrowId})`}
            >
              <path d="M313 63 C425 65 444 153 408 215" />
              <path d="M325 307 Q240 355 155 307" />
              <path d="M72 222 C38 130 85 63 163 63" />
            </g>
          </svg>
          {[
            ['lena', 'cat'],
            ['daniel', 'bear'],
            ['kate', 'fox'],
          ].map(([name, picture], index) => (
            <div
              key={name}
              className={`circle-draw-help__person circle-draw-help__person--${index}`}
            >
              <ParticipantFace picture={picture} />
              <strong>{t(`game.draw.circleHelp.people.${name}.name`)}</strong>
              <span>{t(`game.draw.circleHelp.people.${name}.gives`)}</span>
            </div>
          ))}
          {[0, 1, 2].map((index) => (
            <span
              key={index}
              className={`circle-draw-help__gift circle-draw-help__gift--${index}`}
              aria-hidden="true"
            >
              <ThemeArtwork role="gift" className="circle-draw-help__gift-art" />
            </span>
          ))}
          <p className="circle-draw-help__center">{t('game.draw.circleHelp.oneGift')}</p>
        </div>
      </figure>
      <Typography as="p" role="body/base">
        {t('game.draw.circleHelp.noSelf')}
      </Typography>
      <div className="circle-draw-help__odd">
        <Typography as="h3" role="body/strong">
          {t('game.draw.circleHelp.oddQuestion')}
        </Typography>
        <Typography as="p" role="body/base">
          {t('game.draw.circleHelp.oddAnswer')}
        </Typography>
      </div>
    </Stack>
  );
}

export function AfterDrawHelp() {
  const { t } = useTranslation();
  return <Stack gap={4} className="circle-draw-help">
    <Typography as="p" role="body/base">{t('game.draw.afterHelp.confirm')}</Typography>
    <Typography as="p" role="body/base">{t('game.draw.afterHelp.participant')}</Typography>
    <Typography as="p" role="body/base"><Trans i18nKey="game.draw.afterHelp.organizer" components={{ strong: <strong /> }} /></Typography>
  </Stack>;
}
